"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupMembersApi = void 0;
var tslib_1 = require("tslib");
var http_1 = require("@wix/ambassador-social-groups-v2-group-member/http");
var http_2 = require("@wix/ambassador-social-groups-v2-join-group-request/http");
var http_3 = require("@wix/ambassador-social-groups-v2-group-role/http");
var BaseApi_1 = require("../BaseApi");
var accessRestriction_1 = require("../../model/v2/Group/accessRestriction");
var Membership_1 = require("../../model/v2/Membership");
// https://bo.wix.com/wix-docs/rest/drafts/social-groups-v2/group-member
var GroupMembersApi = /** @class */ (function (_super) {
    tslib_1.__extends(GroupMembersApi, _super);
    function GroupMembersApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // groupId: Membership
        _this.membershipsCache = new Map();
        return _this;
    }
    GroupMembersApi.prototype.queryGroupMembers = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_1.queryGroupMembers(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupMembersApi.prototype.listGroupMembers = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_1.listGroupMembers(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupMembersApi.prototype.addGroupMembers = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_1.addGroupMembers(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupMembersApi.prototype.removeGroupMembers = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_1.removeGroupMembers(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/];
                }
            });
        });
    };
    GroupMembersApi.prototype.assignRole = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_3.assignRole(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupMembersApi.prototype.unassignRole = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_3.unassignRole(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupMembersApi.prototype.leaveGroup = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_1.leaveGroup(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        this.membershipsCache.delete(payload.groupId);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupMembersApi.prototype.joinGroup = function (group, membershipQuestionAnswers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, accessRestriction, joinRequest, httpClient, res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = group.id, accessRestriction = group.accessRestriction;
                        joinRequest = {
                            groupId: id,
                            membershipQuestionAnswers: membershipQuestionAnswers,
                        };
                        httpClient = this.getHTTPClient();
                        if (accessRestriction_1.restrictedByAdmin(accessRestriction)) {
                            return [2 /*return*/, this.submitJoinRequest(joinRequest)];
                        }
                        return [4 /*yield*/, httpClient.request(http_1.joinGroup(joinRequest))];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    GroupMembersApi.prototype.submitJoinRequest = function (joinRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, groupId, mem, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        groupId = joinRequest.groupId;
                        return [4 /*yield*/, this.queryMemberships([groupId])];
                    case 1:
                        mem = _a.sent();
                        if ((mem === null || mem === void 0 ? void 0 : mem[groupId]) && Membership_1.pending(mem[groupId])) {
                            return [2 /*return*/, this.cancelJoinGroupRequest(joinRequest)];
                        }
                        return [4 /*yield*/, httpClient.request(http_2.submitJoinGroupRequest(joinRequest))];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupMembersApi.prototype.cancelJoinGroupRequest = function (joinRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_2.cancelJoinGroupRequest(joinRequest))];
                    case 1:
                        data = (_a.sent()).data;
                        this.membershipsCache.delete(joinRequest.groupId);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    // https://bo.wix.com/wix-docs/rest/drafts/social-groups-v2/group-member/query-memberships
    GroupMembersApi.prototype.queryMemberships = function (groupIds) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _b, _memberships, _groupIds, data, memberships;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.isUserLoggedIn()) {
                            return [2 /*return*/];
                        }
                        _b = tslib_1.__read(this.getMembershipsFromCache(groupIds), 2), _memberships = _b[0], _groupIds = _b[1];
                        if (!_groupIds.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._queryMemberships(_groupIds)];
                    case 1:
                        data = _c.sent();
                        memberships = (_a = data === null || data === void 0 ? void 0 : data.memberships) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, mem) {
                            var groupId = mem.groupId;
                            acc[groupId] = mem;
                            _this.membershipsCache.set(groupId, mem);
                            return acc;
                        }, {});
                        Object.assign(_memberships, memberships);
                        _c.label = 2;
                    case 2: return [2 /*return*/, _memberships];
                }
            });
        });
    };
    GroupMembersApi.prototype.getMembershipsFromCache = function (groupIds) {
        var _this = this;
        return groupIds.reduce(function (acc, id) {
            if (_this.membershipsCache.has(id)) {
                acc[0][id] = _this.membershipsCache.get(id);
            }
            else {
                acc[1].push(id);
            }
            return acc;
        }, [{}, []]);
    };
    GroupMembersApi.prototype._queryMemberships = function (groupIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, id, query, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        id = this.getCurrentUser().id;
                        query = {
                            filter: {
                                groupId: {
                                    $hasSome: groupIds,
                                },
                            },
                            paging: {
                                offset: 0,
                                limit: groupIds.length,
                            },
                        };
                        return [4 /*yield*/, httpClient.request(http_1.queryMemberships({ siteMemberId: id, query: query, memberId: id }))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupMembersApi.prototype.queryPendingJoinRequests = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, q, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        q = tslib_1.__assign({ query: {
                                filter: {
                                    status: {
                                        $eq: 'PENDING',
                                    },
                                },
                                paging: {
                                    offset: 0,
                                    limit: 100,
                                },
                            } }, payload);
                        return [4 /*yield*/, httpClient.request(http_2.queryJoinGroupRequests(q))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupMembersApi.prototype.approveJoinGroupRequests = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_2.approveJoinGroupRequests(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupMembersApi.prototype.rejectJoinGroupRequests = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_2.rejectJoinGroupRequests(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return GroupMembersApi;
}(BaseApi_1.BaseApi));
exports.GroupMembersApi = GroupMembersApi;
//# sourceMappingURL=GroupMembersApi.js.map